import { z } from 'zod/v4';
export var Channel;
(function (Channel) {
    Channel["ServiceDesk"] = "SERVICE_DESK";
    Channel["Email"] = "EMAIL";
    Channel["Phone"] = "PHONE";
})(Channel || (Channel = {}));
export var CustomerCarePlan;
(function (CustomerCarePlan) {
    CustomerCarePlan["Standard"] = "STANDARD";
    CustomerCarePlan["Premium"] = "PREMIUM";
    CustomerCarePlan["Enterprise"] = "ENTERPRISE";
    CustomerCarePlan["Custom"] = "CUSTOM";
})(CustomerCarePlan || (CustomerCarePlan = {}));
export const CustomerCareSchema = z.intersection(z.object({
    monthlyPrice: z.number(),
    supportUserIds: z.array(z.string()),
}), z.discriminatedUnion('type', [
    z.object({
        type: z.literal(CustomerCarePlan.Custom),
        details: z.object({
            initialResponseTimeMS: z.number(),
            quantitySupportUsers: z.number(),
            channels: z.array(z.enum(Channel)),
            hourlyPriceForConsultancy: z.number(),
            sla: z.boolean(),
            dedicatedContactPerson: z.boolean(),
            firstLevelSupport: z.boolean(),
        }),
    }),
    z.object({
        type: z.literal(CustomerCarePlan.Standard),
        details: z.object({}),
    }),
    z.object({
        type: z.literal(CustomerCarePlan.Premium),
        details: z.object({}),
    }),
    z.object({
        type: z.literal(CustomerCarePlan.Enterprise),
        details: z.object({}),
    }),
]));
const supportUserQuantity = {
    [CustomerCarePlan.Enterprise]: 10,
    [CustomerCarePlan.Premium]: 3,
    [CustomerCarePlan.Standard]: 1,
};
export const getSupportUserQuantity = (customerCare) => {
    return (supportUserQuantity[customerCare.type] ||
        (customerCare.type === CustomerCarePlan.Custom
            ? customerCare.details.quantitySupportUsers
            : 0));
};
//# sourceMappingURL=index.js.map